import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

export interface ChartEntitlementDetailsData {
  chartName: string;
  chartVersion: string;
  packagedDateTime: string;
  lighthouseId: string;
  userEmail: string;
}

@Component({
  selector: 'app-chart-entitlement-details',
  templateUrl: './chart-entitlement-details.component.html',
  styleUrls: ['./chart-entitlement-details.component.scss']
})
export class ChartEntitlementDetailsComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ChartEntitlementDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChartEntitlementDetailsData,
    public translateService: TranslateService,
  ) { }

  ngOnInit(): void {
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
